import { render, staticRenderFns } from "./weekSlider.vue?vue&type=template&id=5cb8a790&scoped=true"
import script from "./weekSlider.vue?vue&type=script&lang=js"
export * from "./weekSlider.vue?vue&type=script&lang=js"
import style0 from "./weekSlider.vue?vue&type=style&index=0&id=5cb8a790&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb8a790",
  null
  
)

export default component.exports